// extracted by mini-css-extract-plugin
module.exports = {"headCell":"TableHeaderCellQ_headCell__1oOGZ","icon":"TableHeaderCellQ_icon__N85Nt"};